import { useEffect } from 'react'
import { usePaymentOrder } from '../../components/context/PaymentOrderContext'
import Big from 'big.js'
import { formatCurrency } from 'medere-ui-framework'

function PaymentOrderHeader({ className = "", fullInformation = false }: { className?: string, fullInformation?: boolean }) {
    const { supplier, sinceDate, untilDate, invoices, totalToPay } = usePaymentOrder()

    if (fullInformation) {
        return (
            <div className={className + ' flex gap-8'}>
                <div className='flex flex-column gap-2'>
                    <h2 className="font-bold text-base">  {supplier?.commercialname + ' (' + (sinceDate ? sinceDate.toLocaleDateString() : new Date(new Date().getFullYear(), new Date().getMonth(), 1).toLocaleDateString()) + ' - ' + (untilDate ? untilDate.toLocaleDateString() : new Date().toLocaleDateString()) + ') '}</h2>
                    <h2 className="font-bold text-base">TOTAL A PAGAR: <span>{formatCurrency(Number(totalToPay), {
                        currency: 'ARS',
                        maximumFractionDigits: 2
                    })}</span></h2>
                    {supplier?.paymentconditiondesc && <p className="italic font-sans lowercase">{supplier?.paymentconditiondesc}</p>}
                </div>
                <div className='flex flex-column gap-2'>
                    <h3 className='uppercase font-bold'>Facturas a pagar</h3>
                    <span className='flex'>
                        {invoices?.map((item:any) => (
                            <span className='flex' key={item.administrativeform}>
                                <p>{item.formnumber}</p>
                                <p>-</p>
                                <p>{item.posnumber}</p>
                                <p className='mx-1'>|</p>
                            </span>
                        ))}
                    </span>
                </div>
            </div>
        )
    }

    return (
        <div className={className}>
            <h2 className="font-bold text-base">{supplier?.commercialname}</h2>
            <h3 className='uppercase text-xs'>{`Período desde ${sinceDate ? sinceDate?.toLocaleDateString() : new Date(new Date().getFullYear(), new Date().getMonth(), 1).toLocaleDateString()} hasta ${untilDate ? untilDate?.toLocaleDateString() : new Date()?.toLocaleDateString()}`}</h3>
        </div>
    )
}

export default PaymentOrderHeader
